export default "__VITE_ASSET__BxRTIrXM__"